import React from 'react';
import { Outlet } from 'react-router-dom';
import { SidebarLayout } from '../shared/SidebarLayout';

const NAV = [
  { to:'/dashboard',             label:'Mi Tienda',      icon:'🏪', end:true },
  { to:'/dashboard/productos',   label:'Productos',      icon:'📦' },
  { to:'/dashboard/config',      label:'Configuración',  icon:'⚙️' },
];

export default function ClientLayout() {
  return (
    <SidebarLayout navItems={NAV} title="Mi Panel" subtitle="Panel de cliente">
      <Outlet />
    </SidebarLayout>
  );
}
